import { createContext } from "react";
import { noop } from "@common/helpers/function";
import { FinancialAccount } from "@common/types/financialAccount";
import { CheckForImporterErrorsOptions } from "@api/financialDocument.api";
import { ImporterDocumentRow, ImporterSort } from "./types";

interface ImporterContextValue {
    importerQueue: string;
    documentRows: ImporterDocumentRow[];
    sortedRows: ImporterDocumentRow[];
    sort: ImporterSort | undefined;
    previewedRowId?: string;
    reconciliedFinancialAccount?: FinancialAccount;
    refreshEnabled: boolean;
    setSort: (sort: ImporterSort | undefined) => void;
    setPreviewedRowId: (rowId: string | undefined) => void;
    upsertDocumentRow: (documentRow: ImporterDocumentRow) => void;
    updateDocumentRow: (
        id: string,
        documentRow: Partial<Omit<ImporterDocumentRow, "id">>,
    ) => void;
    removeDocumentRow: (documentRow: ImporterDocumentRow) => void;
    revalidateDocument: (options: CheckForImporterErrorsOptions) => void;
    setRefreshEnabled: (refreshEnabled: boolean) => void;
    readyToImportLabel: string;
    entityIdByStatementAccountKey: ReadonlyMap<string, number>;
    setStatementAccountEntity: (params: {
        key: string;
        entityId: number | null;
    }) => void;
}

export const ImporterContext = createContext<ImporterContextValue>({
    importerQueue: "",
    documentRows: [],
    sortedRows: [],
    sort: undefined,
    refreshEnabled: false,
    setSort: noop,
    setPreviewedRowId: noop,
    upsertDocumentRow: noop,
    updateDocumentRow: noop,
    removeDocumentRow: noop,
    revalidateDocument: noop,
    setRefreshEnabled: noop,
    readyToImportLabel: "",
    entityIdByStatementAccountKey: new Map(),
    setStatementAccountEntity: noop,
});
